<div class="form-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Neues Konto erstellen</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      @if (!successMessage) {
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="outline">
            <mat-label>Benutzername</mat-label>
            <mat-icon matPrefix>person</mat-icon>
            <input matInput formControlName="username" required />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>E-Mail</mat-label>
            <mat-icon matPrefix>email</mat-icon>
            <input matInput formControlName="email" type="email" required />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Passwort</mat-label>
            <mat-icon matPrefix>lock</mat-icon>
            <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" required />
            <button
              mat-icon-button
              matSuffix
              (click)="hidePassword = !hidePassword"
              type="button"
              aria-label="Passwort anzeigen/verbergen"
            >
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>

          <button mat-raised-button color="primary" type="submit" [disabled]="registerForm.invalid">
            Konto erstellen
          </button>
        </form>
      } @else {
        <div class="success-message">
          <p>{{ successMessage }}</p>
          <p>Du wirst in Kürze weitergeleitet...</p>
        </div>
      }
    </mat-card-content>

    <mat-card-footer>
      <p>Bereits ein Konto? <a routerLink="/login">Hier anmelden.</a></p>
    </mat-card-footer>
  </mat-card>
</div>
